import * as types from "../actions/actionTypes";
const initialState = {
  data: [],
  loading: false,
  isFetched: false,
  modalStatus: false,
  modalData: {},
  titles_loading: false,
  titles_fetched: false,
  titles: []
};

const Feedback = (state = initialState, action) => {
  switch (action.type) {
    case types.FEEDBACK_LIST_REQUEST:
      return { ...state, loading: true };
    case types.FEEDBACK_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payLoad,
        isFetched: true
      };
    case types.FEEDBACK_LIST_FAILURE:
      return { ...state, loading: false };

    case types.FEEDBACK_STORE_REQUEST:
      return { ...state, loading: true };
    case types.FEEDBACK_STORE_SUCCESS:
      if (state.data.length) {
        state.data.unshift(action.payLoad);
      }
      return { ...state, loading: false, modalStatus: false, modalData: {} };
    case types.FEEDBACK_STORE_FAILURE:
      return { ...state, loading: false };
    case types.FEEDBACK_SCORE_REQUEST:
      return { ...state };
    case types.FEEDBACK_SCORE_SUCCESS:
      return { ...state, loading: false };
    case types.FEEDBACK_SCORE_FAILURE:
      return { ...state, loading: false };
    default:
      return state;

    case types.FEEDBACK_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.FEEDBACK_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: {} };
    case types.FEEDBACK_TITLES_REQUEST:
      return { ...state, titles_loading: true };
    case types.FEEDBACK_TITLES_SUCCESS:
      return {
        ...state,
        titles: action.payLoad,
        titles_loading: false,
        titles_fetched: true
      };
    case types.FEEDBACK_TITLES_FAILURE:
      return { ...state, titles_loading: false };

    case types.FEEDBACK_READ_REQUEST:
      return { ...state };
  }
};

export default Feedback;
